@if (isContentLoading()) {
<mat-progress-bar class=" rounded layout-shop__progress-bar" mode="indeterminate" value="accent"></mat-progress-bar>
}
<div class="layout-shop" [class.layout--sidebar-closed]="!isSidebarOpen()">
  <!-- Sidebar — wrapper always present to reserve width and prevent CLS -->
  <div class="layout-shop__sidebar height-layout-global-message" [class.sidebar--closed]="!isSidebarOpen()">
    @if (isContentLoaded()) {
    <div class="overlay" (click)="toggleSidebar()"></div>
    <app-sidebar (outIsMenuReady)="scrollIntoView()"></app-sidebar>
    <div class="toggle-sidebar" (click)="toggleSidebar()" (mouseenter)="toggleCollapseBarHover(true)"
      (mouseleave)="toggleCollapseBarHover(false)">
      <i [ngClass]="{
          'fas': true,
          'fw-bolder': true,
          'toggle-sidebar__icon': true,
          'fa-angles-right': !isSidebarOpen(),
          'fa-angles-left': isSidebarOpen(),
        }"></i>
    </div>
    }
  </div>

  <!-- Main content -->
  <div class="layout-shop__main height-layout-shop__main-global-message" id="layoutShopMain" name="scroll-to-top-ref">

    @if(!marketStatus().isOpen) {
    <div class="closed-market-container animated fadeIn">
      <div class="alert" role="alert">
        <span class="material-symbols-outlined mat-icon-fill icon">
          calendar_today
        </span>
        <div class="text-container">

          <p class="header">{{closedMarket().title}}</p>
          <p class="legend">{{closedMarket().legend}}</p>
        </div>
      </div>
    </div>
    }

    <div class="container-fluid">

      <div class="filter-chips-wrapper" [style.min-height.px]="filters().size ? 50 : 0">
        @if (filters().size) {
        <ul class="filter-chips-container">
          @for (filter of filters().entries(); track trackByFilterKey($index, filter)) {
          <li>
            <mat-chip-row (removed)="removeChipFilter(filter[0])" [editable]="true" class="bg-secondary bg-opacity-25">
              <div class="d-flex gap-1">
                <b>{{filter[1].type}}:</b> <span class="fst-italic text-decoration-underline">{{filter[1].value}}</span>
              </div>
              <button matChipRemove [attr.aria-label]="'remove ' + filter[0]">
                <span class="material-symbols-outlined">
                  close
                </span>
              </button>
            </mat-chip-row>
          </li>
          }
        </ul>
        }
      </div>

      @if (!isContentLoading() && isContentLoaded()) {
      @if (!productsSignal().length) {
      <app-empty-message [message]="emptyMessage" class="mt-4"></app-empty-message>
      }
      }

      <div class="row product-card-grid" id="scroll-to-top-ref">
        @if (productsSignal()) {

        @for (product of productsSignal(); track product.id; let idx = $index) {

        <!-- PRODUCT CATEGORY -->
        @if (product.categoryInView) {
        <div #subcategory [attr.shop-data-anchor-link]="product.categoryAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="-1">
          @if (getCategoryBanner(product.category.id); as categoryBanner) {
          <a [href]="categoryBanner.url ? categoryBanner.url : 'javascrip:void(0)'">

            <img [ngSrc]="categoryBanner.banner" alt="Banner of category: {{product.subcategory.name}}"
              [class]="'img-fluid w-100 mb-4 shop-banner-img' + (idx > 0 ? ' animated fadeInDown' : '')"
              [width]="categoryBanner.width" [height]="categoryBanner.height"
              [priority]="idx === 0"
              (load)="onBannerLoad($event)">
          </a>
          } @else if(displayCategoryName()) {
          <h3 class="mb-2 mb-sm-4">
            {{ product.category.name }}
          </h3>
          }
        </div>
        }
        <!-- PRODUCT CATEGORY ENDS -->

        <!-- PRODUCT SUBCATEGORY -->
        @if (product.subCategoryInView) {
        <div #subcategory [attr.shop-data-anchor-link]="product.subcategoryAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id">
          @if (getSubCategoryBanner(product.category.id, product.subcategory.id); as subcategoryBanner) {
          <a [href]="subcategoryBanner.url ? subcategoryBanner.url : 'javascrip:void(0)'">

            <img [ngSrc]="subcategoryBanner.banner" alt="Banner of subcategory: {{product.subcategory.name}}"
              [class]="'img-fluid w-100 mb-4 shop-banner-img' + (idx > 0 ? ' animated fadeInDown' : '')"
              [width]="subcategoryBanner.width" [height]="subcategoryBanner.height"
              [priority]="idx === 0 && !(product.categoryInView && getCategoryBanner(product.category.id))"
              (load)="onBannerLoad($event)">

          </a>
          } @else {
          <h3 class="mb-2 mb-sm-4">
            {{ product.subcategory.name }}
          </h3>
          }
        </div>
        }
        <!-- PRODUCT SUBCATEGORY ENDS-->

        <!-- LCP optimization: first two desktop rows (4-col grid → 8 cards) load
             eagerly so the initial viewport has no skeletons; the rest are
             deferred. Bumped from 6 to 8 because 6 left the last 2 cards of the
             second visible row showing the @defer placeholder on tall screens. -->
        @if (idx < 8) { <!-- Above-the-fold products: render immediately with high priority -->
          <div class="col-xxl-3 col-lg-3 col-sm-4 col-6" id="{{product.id}}"
            (mouseenter)="onProductCardHover(product.id)">
            <div class="product-card-grid__item">
              @let productDetails = this.productDetails().get(product.id);
              <app-product-card-v2 [cardResume]="{ product, settings: {}, productDetails }"
                (onComponentReady)="onProductCardReady(product.id)" [isFromShop]="!!productDetails"
                [isAboveTheFold]="true">
              </app-product-card-v2>
            </div>
          </div>
          } @else {
          <!-- Below-the-fold products: defer loading until viewport -->
          @defer (on viewport; prefetch on immediate) {
          <div class="col-xxl-3 col-lg-3 col-sm-4 col-6" id="{{product.id}}"
            (mouseenter)="onProductCardHover(product.id)">
            <div class="product-card-grid__item">
              @let productDetails = this.productDetails().get(product.id);
              <app-product-card-v2 [cardResume]="{ product, settings: {}, productDetails }"
                (onComponentReady)="onProductCardReady(product.id)" [isFromShop]="!!productDetails"
                [isAboveTheFold]="false">
              </app-product-card-v2>
            </div>
          </div>
          } @placeholder {
          <div class="col-xxl-3 col-lg-3 col-sm-4 col-6" id="{{product.id}}">
            <div class="product-card-grid__item" aria-hidden="true">
              <!-- `.product-card` wrapper makes `.product-card__img { height: 150px }`
                   apply to the placeholder, so its height matches a rendered card.
                   Without it, the placeholder is much shorter, the IntersectionObserver
                   of @defer fits many of them in the viewport at once, and the initial
                   detail-fetch batch swells beyond the actually-visible products. -->
              <div class="product-card">
                <div class="product-card__img mb-0"></div>
                <!-- Product Name -->
                <h6 class="card-title placeholder-glow my-2">
                  <span class="placeholder bg-secondary col-12"></span>
                </h6>
                <!-- Producer Name -->
                <h6 class="placeholder-glow m-0">
                  <span class="placeholder bg-secondary col-6"></span>
                </h6>
                <!-- Producer Location -->
                <h6 class="placeholder-glow mt-2 mb-0">
                  <span class="placeholder bg-secondary col-8"></span>
                </h6>
                <!-- Product Price and Quantity -->
                <h2 class="placeholder-glow mb-4 mt-2">
                  <span class="placeholder bg-secondary col-12"></span>
                </h2>
                <!-- Product Variants -->
                <h2 class="placeholder-glow m-0">
                  <span class="placeholder bg-secondary col-12"></span>
                </h2>
                <!-- Product Display -->
                <h6 class="placeholder-glow mt-3 mb-0">
                  <span class="placeholder bg-secondary col-4"></span>
                </h6>
                <!-- Product Description -->
                <div class="placeholder bg-secondary col-12 mt-3" style="height: 50px;"></div>
                <!-- Product Add Button -->
                <div class="placeholder bg-secondary col-12 mt-3" style="height: 36px;"></div>
              </div>
            </div>
          </div>
          }
          }
          }
          }

      </div>
    </div>
  </div>
</div>